import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const WildlifeSummaryRow = ({image, animalClass, speciesCount}) => {
  return (
    <div className="WildlifeSummaryRow">
      <div className={classNames(
        "WildlifeSummaryRow__image",
        `WildlifeSummaryRow__image--${animalClass}`)}
      />
      <p className="WildlifeSummaryRow__title">{animalClass}</p>
      <p className="WildlifeSummaryRow__speciesCount">{`${speciesCount} sp.`}</p>
    </div>
  );
};

WildlifeSummaryRow.propTypes = {
  animalClass: PropTypes.string.isRequired,
  speciesCount: PropTypes.number.isRequired,
};

export default WildlifeSummaryRow;



// WEBPACK FOOTER //
// ./src/components/WildlifeSummaryRow.js